/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Directory_JoinInputs */

const en_us2_clubs_directory_join = /** @type {(inputs: Clubs_Directory_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join`)
};

const pt_br2_clubs_directory_join = /** @type {(inputs: Clubs_Directory_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const es_419_clubs_directory_join = /** @type {(inputs: Clubs_Directory_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unirme`)
};

const pt_pt2_clubs_directory_join = /** @type {(inputs: Clubs_Directory_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar`)
};

const fr_fr2_clubs_directory_join = /** @type {(inputs: Clubs_Directory_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejoindre`)
};

const de_de2_clubs_directory_join = /** @type {(inputs: Clubs_Directory_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beitreten`)
};

const it_it2_clubs_directory_join = /** @type {(inputs: Clubs_Directory_JoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entra`)
};

/**
* | output |
* | --- |
* | "Join" |
*
* @param {Clubs_Directory_JoinInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_directory_join = /** @type {((inputs?: Clubs_Directory_JoinInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Directory_JoinInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_directory_join(inputs)
	if (locale === "es-419") return es_419_clubs_directory_join(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_directory_join(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_directory_join(inputs)
	if (locale === "de-DE") return de_de2_clubs_directory_join(inputs)
	if (locale === "it-IT") return it_it2_clubs_directory_join(inputs)
	return en_us2_clubs_directory_join(inputs)
});
export { clubs_directory_join as "clubs.directory_join" }